// One accent colour per module. Drives page banners, nav tabs, table headers and grid stripes.
export const MODULE_THEMES = {
  dashboard: { name: "Dashboard", primary: "#4F46E5", dark: "#312E81", tint: "#EEF2FF", border: "#A5B4FC", head: "#E0E7FF", stripe: "#F5F7FF", hover: "#E8ECFF" },
  sales: { name: "Sales", primary: "#059669", dark: "#064E3B", tint: "#ECFDF5", border: "#6EE7B7", head: "#D1FAE5", stripe: "#F3FDF8", hover: "#E3F9EE" },
  purchase: { name: "Purchase", primary: "#D97706", dark: "#78350F", tint: "#FFFBEB", border: "#FDE68A", head: "#FEF3C7", stripe: "#FFFCF2", hover: "#FEF6DC" },
  inventory: { name: "Inventory", primary: "#0D9488", dark: "#134E4A", tint: "#F0FDFA", border: "#5EEAD4", head: "#CCFBF1", stripe: "#F2FEFB", hover: "#DEFAF4" },
  items: { name: "Item Master", primary: "#7C3AED", dark: "#4C1D95", tint: "#F5F3FF", border: "#C4B5FD", head: "#EDE9FE", stripe: "#F9F7FF", hover: "#EFEAFF" },
  mill: { name: "Mill Orders", primary: "#0284C7", dark: "#0C4A6E", tint: "#F0F9FF", border: "#7DD3FC", head: "#BAE6FD", stripe: "#F5FBFF", hover: "#E3F3FE" },
  reports: { name: "Reports", primary: "#E11D48", dark: "#881337", tint: "#FFF1F2", border: "#FDA4AF", head: "#FFE4E6", stripe: "#FFF7F8", hover: "#FFECEE" },
  hisab: { name: "Hisab", primary: "#C026D3", dark: "#701A75", tint: "#FDF4FF", border: "#F0ABFC", head: "#FAE8FF", stripe: "#FEF8FF", hover: "#F9EBFE" },
  finance: { name: "Ledgers & Vouchers", primary: "#EA580C", dark: "#7C2D12", tint: "#FFF7ED", border: "#FDBA74", head: "#FFEDD5", stripe: "#FFFAF4", hover: "#FFF0DC" },
  booking: { name: "Booking", primary: "#0E7490", dark: "#083344", tint: "#ECFEFF", border: "#67E8F9", head: "#CFFAFE", stripe: "#F3FEFF", hover: "#DFFAFE" },
  admin: { name: "Admin", primary: "#475569", dark: "#0F172A", tint: "#F8FAFC", border: "#CBD5E1", head: "#E2E8F0", stripe: "#F8FAFC", hover: "#F1F5F9" },
};

const ROUTE_MAP = [
  ["/mill-orders", "mill"],
  ["/purchase-register", "purchase"],
  ["/conference", "booking"],
  ["/purchase-orders", "purchase"],
  ["/purchase", "purchase"],
  ["/sales", "sales"],
  ["/adjustments", "inventory"],
  ["/transfers", "inventory"],
  ["/inventory", "inventory"],
  ["/items", "items"],
  ["/masters", "items"],
  ["/profit-report", "reports"],
  ["/bale-report", "reports"],
  ["/expense-report", "reports"],
  ["/reports", "reports"],
  ["/hisab", "hisab"],
  ["/customers", "hisab"],
  ["/party-ledger", "finance"],
  ["/ledger", "finance"],
  ["/journal", "finance"],
  ["/payment-entry", "finance"],
  ["/receipt-entry", "finance"],
  ["/users", "admin"],
  ["/activity", "admin"],
];

export const moduleKeyForPath = (pathname = "") =>
  (ROUTE_MAP.find(([p]) => pathname.startsWith(p)) || [null, "dashboard"])[1];

export const themeForPath = (pathname) => MODULE_THEMES[moduleKeyForPath(pathname)];

export const themeVars = (t) => ({
  "--mod-primary": t.primary,
  "--mod-dark": t.dark,
  "--mod-tint": t.tint,
  "--mod-border": t.border,
  "--mod-head": t.head,
  "--mod-stripe": t.stripe,
  "--mod-hover": t.hover,
});

// Rotating tones for KPI stat cards.
export const STAT_TONES = [
  { bg: "#EEF2FF", bar: "#4F46E5", label: "#4338CA", value: "#312E81" },
  { bg: "#ECFDF5", bar: "#059669", label: "#047857", value: "#064E3B" },
  { bg: "#FFFBEB", bar: "#D97706", label: "#B45309", value: "#78350F" },
  { bg: "#FFF1F2", bar: "#E11D48", label: "#BE123C", value: "#881337" },
  { bg: "#F0FDFA", bar: "#0D9488", label: "#0F766E", value: "#134E4A" },
  { bg: "#F5F3FF", bar: "#7C3AED", label: "#6D28D9", value: "#4C1D95" },
  { bg: "#F0F9FF", bar: "#0284C7", label: "#0369A1", value: "#0C4A6E" },
  { bg: "#FDF4FF", bar: "#C026D3", label: "#A21CAF", value: "#701A75" },
  { bg: "#FFF7ED", bar: "#EA580C", label: "#C2410C", value: "#7C2D12" },
];

// Top-menu colours so every menu group reads as its own module.
export const MENU_COLORS = {
  Dashboard: MODULE_THEMES.dashboard.primary,
  Admin: MODULE_THEMES.items.primary,
  Transactions: MODULE_THEMES.sales.primary,
  Hisab: MODULE_THEMES.hisab.primary,
  Display: MODULE_THEMES.reports.primary,
  Booking: MODULE_THEMES.booking.primary,
};
